import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { baseUrl } from "../Univ";

function WorkflowHistory() {

    const [transactions, setTransactions] = useState([]);
    const [history, setHistory] = useState([]);
    const [selectedTransaction, setSelectedTransaction] = useState("");

    const [searchParams] = useSearchParams();

    const transactionId = searchParams.get("transaction");

    useEffect(() => {
        loadTransactions();
    }, []);

    useEffect(() => {

        if (transactionId && transactions.length > 0) {

            setSelectedTransaction(transactionId);

            loadHistory(transactionId);

        }

    }, [transactionId, transactions]);

    const loadTransactions = () => {

        axios
            .get(baseUrl + "workflow-transaction/")
            .then((res) => {

                setTransactions(res.data);

            })
            .catch(() => {

                Swal.fire(
                    "Error",
                    "Unable to load transactions",
                    "error"
                );

            });

    };

    const loadHistory = (id) => {

        if (!id) return;

        setSelectedTransaction(id);

        axios
            .get(baseUrl + "workflow-history/?transaction=" + id)
            .then((res) => {

                setHistory(res.data);

            })
            .catch(() => {

                Swal.fire(
                    "Error",
                    "Unable to load workflow history",
                    "error"
                );

            });

    };

    return (

        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Workflow History
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row mb-3">

                        <div className="col-md-4">

                            <label>
                                Select Transaction
                            </label>

                            <select
                                className="form-select"
                                value={selectedTransaction}
                                onChange={(e) => loadHistory(e.target.value)}
                            >

                                <option value="">
                                    Select Transaction
                                </option>

                                {transactions.map((item) => (

                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >

                                        {item.document_type}
                                        {" - "}
                                        {item.document_id}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                    <hr />

                    {history.length === 0 ? (

                        <div className="alert alert-warning">

                            No Workflow History Found

                        </div>

                    ) : (

                        <div className="timeline">

                            {history.map((item, index) => (

                                <div
                                    className="card shadow mb-3"
                                    key={item.id}
                                >

                                    <div className="card-body">

                                        <h5>

                                            {index === 0
                                                ? "🟢"
                                                : "➡️"}{" "}

                                            {item.action}

                                        </h5>

                                        <p>

                                            <strong>
                                                Stage :
                                            </strong>{" "}

                                            {item.stage.stage_name}

                                        </p>

                                        <p>

                                            <strong>
                                                Action By :
                                            </strong>{" "}

                                            {item.action_by.username}

                                        </p>

                                        <p>

                                            <strong>
                                                Remarks :
                                            </strong>{" "}

                                            {item.remarks || "No Remarks"}

                                        </p>

                                        <small className="text-muted">

                                            {item.action_date}

                                        </small>

                                    </div>

                                </div>

                            ))}

                        </div>

                    )}

                </div>

            </div>

        </div>

    );

}

export default WorkflowHistory;